import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import InviteUsersModal from './InviteUsersModal';

function InviteUsersButton(): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  function handleOpenModal(): void {
    setIsModalOpen(true);
  }

  function handleCloseModal(): void {
    setIsModalOpen(false);
  }

  return (
    <>
      <Button onClick={handleOpenModal} type={'primary'}>
        {t('Invite users')}
      </Button>
      {isModalOpen && <InviteUsersModal onClose={handleCloseModal} />}
    </>
  );
}

export default InviteUsersButton;
